"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextEditor = exports.RichTextStyle = void 0;
const react_1 = require("@chakra-ui/react");
const draft_js_1 = require("draft-js");
const react_2 = __importStar(require("react"));
const bi_1 = require("react-icons/bi");
const hooks_1 = require("../hooks");
const HackerButton_1 = require("./HackerButton");
const HackerIconButton_1 = require("./HackerIconButton");
var RichTextStyle;
(function (RichTextStyle) {
    RichTextStyle["Bold"] = "BOLD";
    RichTextStyle["Italic"] = "ITALIC";
    RichTextStyle["Underline"] = "UNDERLINE";
    RichTextStyle["Monospace"] = "MONOSPACE";
    RichTextStyle["Strikethrough"] = "STRIKETHROUGH";
})(RichTextStyle = exports.RichTextStyle || (exports.RichTextStyle = {}));
function initializeEditorState(blocks) {
    if (!blocks)
        return draft_js_1.EditorState.createEmpty();
    return draft_js_1.EditorState.createWithContent((0, draft_js_1.convertFromRaw)({
        entityMap: {},
        blocks: blocks.map((block, index) => {
            return {
                text: block.text,
                inlineStyleRanges: block.inlineStyleRanges,
                type: 'unstyled',
                depth: 1,
                key: `${index}`,
                entityRanges: [],
            };
        }),
    }));
}
function extractTextBlocksFromEditorState(editorState) {
    const rawContent = (0, draft_js_1.convertToRaw)(editorState.getCurrentContent());
    return rawContent.blocks.map((block) => {
        return {
            text: block.text,
            inlineStyleRanges: block.inlineStyleRanges.map((inlineStyleRange) => {
                return {
                    style: inlineStyleRange.style,
                    offset: inlineStyleRange.offset,
                    length: inlineStyleRange.length,
                };
            }),
        };
    });
}
const TextEditor = ({ isSaving, onSave, onCancel, placeholder, textBlocks, isReadOnly, }) => {
    const { primaryColor } = (0, hooks_1.usePrimaryColor)();
    const [editorState, setEditorState] = (0, react_2.useState)(initializeEditorState(textBlocks));
    const handleSave = (0, react_2.useCallback)(() => {
        const textBlocks = extractTextBlocksFromEditorState(editorState);
        onSave === null || onSave === void 0 ? void 0 : onSave(textBlocks, true);
    }, [editorState, onSave]);
    const handleCancel = (0, react_2.useCallback)(() => {
        setEditorState(initializeEditorState(textBlocks));
        onCancel === null || onCancel === void 0 ? void 0 : onCancel();
    }, [onCancel, textBlocks]);
    const handleKeyCommand = (0, react_2.useCallback)((command, editorState) => {
        const newState = draft_js_1.RichUtils.handleKeyCommand(editorState, command);
        if (newState) {
            setEditorState(newState);
            return 'handled';
        }
        return 'not-handled';
    }, []);
    const handleToggleStyle = (0, react_2.useCallback)((style) => {
        setEditorState((editorState) => draft_js_1.RichUtils.toggleInlineStyle(editorState, style));
    }, []);
    const createStyleToggleHandler = (0, react_2.useCallback)((style) => {
        return (event) => {
            event.preventDefault();
            handleToggleStyle(style);
        };
    }, [handleToggleStyle]);
    const currentStyle = editorState.getCurrentInlineStyle();
    return (react_2.default.createElement(react_1.Flex, { minH: "300px", flex: 1, direction: "column", borderColor: primaryColor, borderWidth: isReadOnly ? 0 : '1px', sx: {
            '.DraftEditor-root': {
                flex: 1,
                display: 'flex',
                flexDirection: 'column',
                position: 'relative',
            },
            '.public-DraftEditorPlaceholder-root': {
                position: 'absolute',
                top: 0,
                left: 0.5,
                display: 'inline-block',
                opacity: 0.5,
            },
            '.DraftEditor-editorContainer': {
                flex: 1,
                display: 'flex',
                flexDirection: 'column',
            },
            '.public-DraftEditor-content': {
                flex: 1,
            },
        } },
        react_2.default.createElement(react_1.Flex, { borderColor: primaryColor, borderBottomWidth: "1px", hidden: isReadOnly },
            react_2.default.createElement(HackerIconButton_1.HackerIconButton, { borderWidth: 0, borderRightWidth: "1px", size: "sm", onMouseDown: createStyleToggleHandler(RichTextStyle.Bold), filled: currentStyle.has(RichTextStyle.Bold) },
                react_2.default.createElement(bi_1.BiBold, null)),
            react_2.default.createElement(HackerIconButton_1.HackerIconButton, { borderWidth: 0, borderRightWidth: "1px", size: "sm", onMouseDown: createStyleToggleHandler(RichTextStyle.Italic), filled: currentStyle.has(RichTextStyle.Italic) },
                react_2.default.createElement(bi_1.BiItalic, null)),
            react_2.default.createElement(HackerIconButton_1.HackerIconButton, { borderWidth: 0, borderRightWidth: "1px", size: "sm", onMouseDown: createStyleToggleHandler(RichTextStyle.Underline), filled: currentStyle.has(RichTextStyle.Underline) },
                react_2.default.createElement(bi_1.BiUnderline, null)),
            react_2.default.createElement(HackerIconButton_1.HackerIconButton, { borderWidth: 0, borderRightWidth: "1px", size: "sm", onMouseDown: createStyleToggleHandler(RichTextStyle.Strikethrough), filled: currentStyle.has(RichTextStyle.Strikethrough) },
                react_2.default.createElement(bi_1.BiStrikethrough, null)),
            react_2.default.createElement(react_1.Flex, { flex: 1, justifyContent: "flex-end" },
                onCancel && (react_2.default.createElement(HackerButton_1.HackerButton, { borderWidth: 0, borderLeftWidth: "1px", size: "sm", onClick: handleCancel, isLoading: isSaving }, "Cancel")),
                onSave && (react_2.default.createElement(HackerButton_1.HackerButton, { borderWidth: 0, borderLeftWidth: "1px", size: "sm", onClick: handleSave, isLoading: isSaving }, "Save")))),
        react_2.default.createElement(react_1.Flex, { flex: 1, direction: "column", p: 1, overflowY: "auto" },
            react_2.default.createElement(draft_js_1.Editor, { placeholder: placeholder, editorState: editorState, onChange: setEditorState, handleKeyCommand: handleKeyCommand, readOnly: isReadOnly }))));
};
exports.TextEditor = TextEditor;
//# sourceMappingURL=TextEditor.js.map